import { post } from '../utils/api';

// Ask Addy (the nav assistant) a question. history = prior turns
// [{ role: 'user' | 'assistant', content }], newest last, max 12.
export const sendNavAssistantMessage = ({ message, history, currentPath }) =>
  post('/nav-assistant/message', { message, history, currentPath }, true);
